export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-game-center-204427792eab378ef63a4275d2932892.svg";